/**
 * Ryan O'Dowd
 * 2024-08-06
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import IconButton from '@components/common/IconButton';
import ListItem from '@components/ListItem';
import React from 'react';
import SectionList from '@components/common/SectionList';
import SectionListHeader from '@components/common/SectionList/Header';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';
import {
  removeFromSuperSearchHistory,
} from '@utils/store/actions';

const SearchHistory = (props: SearchHistoryProps) => {
  const dispatch = hooks.useTypedDispatch();
  const i18n = hooks.useI18n();
  const styles = hooks.useStyles(getStyles);

  const superSearchHistory = hooks.useTypedSelector((state) => state.superSearchHistory);

  const _renderSearchHistorySectionHeader = (title) => {
    return <SectionListHeader style={styles.searchHistoryHeaderText}>{title}</SectionListHeader>;
  };

  let superSearchHistorySections: any = { // @TODO: should this be an array since it's overwritten as one below?
    today: {
      key: 'today',
      sortOrder: 1,
      title: i18n('recentSearches'),
      data: [],
    },
    /* @TODO
    thisWeek: {
      key: 'thisWeek',
      sortOrder: 2,
      title: 'This week', // @TODO: i18n
      data: [],
    },
    thisMonth: {
      key: 'thisMonth',
      sortOrder: 3,
      title: 'The month', // @TODO: i18n
      data: [],
    },
    older: {
      key: 'older',
      sortOrder: 4,
      title: 'Older than a month', // @TODO: i18n
      data: [],
    },
    : */
  };
  superSearchHistory.forEach((historyEntry) => {
    // @TODO: if (new Date() >= dateFnsAdd(new Date(historyEntry.lastSearchedTimestamp), {days: -1})) {
    superSearchHistorySections.today.data.push(historyEntry);
    // @TODO: } else if (new Date() >= dateFnsAdd(new Date(historyEntry.lastSearchedTimestamp), {days: -7})) {
    // @TODO: superSearchHistorySections.thisWeek.data.push(historyEntry);
    // @TODO: } else if (new Date() >= dateFnsAdd(new Date(historyEntry.lastSearchedTimestamp), {months: -1})) {
    // @TODO: superSearchHistorySections.thisMonth.data.push(historyEntry);
    // @TODO: } else {
    // @TODO: superSearchHistorySections.older.data.push(historyEntry);
    // @TODO: }
  });
  superSearchHistorySections = Object.values(superSearchHistorySections).sort((a: any, b: any) => { // @TODO: maybe limit each section to 5 best matches or something? with a "show more" option for each one?
    return a.sortOrder - b.sortOrder;
  });

  return (
    <SectionList
      sections={superSearchHistorySections}
      keyboardShouldPersistTaps='handled'
      keyboardDismissMode='on-drag'
      keyExtractor={(item, index) => {
        return `${item.id}-${index}`; // @TODO: should be able to just use item.id}
      }}
      renderItem={({item}) => {
        return (
          <ListItem
            containerStyles={styles.superSearchHistoryListItem}
            onPress={() => props.onItemPress(item.searchText)}
          >
            <View
              key={item.searchText}
              style={styles.superSearchHistoryRow}
            >
              <IconButton// @TODO: replace with swipe to delete
                style={styles.removeButton}
                icon='close'
                iconColor={styles.colors.white}
                size={styles.globalScale * 14}
                onPress={() => dispatch(removeFromSuperSearchHistory(item.searchText))}
              />
              <Text style={styles.superSearchHistoryText}>{item.searchText}</Text>
            </View>
          </ListItem>
        );
      }}
      renderSectionHeader={({section}) => section.data.length > 0 && _renderSearchHistorySectionHeader(section.title)}
    />
  );
};

class SearchHistoryProps {
  onItemPress: (searchText: string) => void;
};

export default SearchHistory;
